<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <global-table
          :table-data="warehouse"
          :loading="loading"
          :per-page="10"
          :bordered="true"
          :table-detail="tableDetail"
          :hover="true"
          :striped="false"
          :fields="fields"
          :row-edit="warehouseForm"
          :redirect-detail="true"
          :show-add-button="true"
          caption="<i class='fa fa-align-justify'></i> Produk Listing"
          addButton="Tambah Produk"
          @resetForm="resetForm"
        ></global-table>
      </b-col>
    </b-row>

    <b-row>
      <b-modal
        ref="myModalRef"
        id="addModals"
        header-border-variant="no-border text-center"
        footer-border-variant="no-border"
        footer-bg-variant="light"
        :no-close-on-backdrop="true"
        :no-close-on-esc="true"
        size="lg"
      >
        <div slot="modal-header" class="text-center">
          <h3 class="text-center">Input Gudang</h3>
        </div>

        <div v-if="loadingSubmit">
          <loading></loading>
        </div>

        <div v-if="!loadingSubmit">
          <b-form id="warehouseForm" validated novalidate>
            <b-row>
              <b-col sm="3">
                <b-form-group label-for="name" label="Nama Gudang">
                  <b-form-input
                    id="name"
                    type="text"
                    v-model="$v.warehouseForm.name.$model"
                    :state="!$v.warehouseForm.name.$invalid"
                    required
                    placeholder="Nama Gudang"
                  ></b-form-input>
                  <b-form-invalid-feedback>Nama Gudang harus di isi.</b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <b-col sm="3">
                <b-form-group label-for="prefix" label="Inisial">
                  <b-form-input
                    id="prefix"
                    type="text"
                    v-model="$v.warehouseForm.prefix.$model"
                    :state="!$v.warehouseForm.prefix.$invalid"
                    required
                    placeholder="Prefix"
                  ></b-form-input>
                  <b-form-invalid-feedback>Inisial harus di isi.</b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <b-col sm="3">
                <b-form-group label-for="related_gt" label="Cakupan Konsumen GT">
                  <multi-select
                    :options="listCoverageGT"
                    :selected-options="item_related_gt"
                    placeholder="-- Harap pilih salah satu --"
                    v-model="$v.warehouseForm.related_gt.$model"
                    :isError="$v.warehouseForm.related_gt.$invalid"
                    @select="onSelectGT"
                  ></multi-select>
                  <div
                    v-if="warehouseForm.related_gt === null || warehouseForm.related_gt.length === 0"
                    class="invalid-feedback-custom"
                  >Group konsumen GT harus di isi.</div>
                </b-form-group>
              </b-col>

              <b-col sm="3">
                <b-form-group label-for="related_non_gt" label="Cakupan Konsumen Non GT">
                  <multi-select
                    :options="listCoverageNonGT"
                    :selected-options="item_related_non_gt"
                    placeholder="-- Harap pilih salah satu --"
                    v-model="$v.warehouseForm.related_non_gt.$model"
                    :isError="$v.warehouseForm.related_non_gt.$invalid"
                    @select="onSelectNonGT"
                  ></multi-select>
                  <div
                    v-if="warehouseForm.related_non_gt === null || warehouseForm.related_non_gt.length === 0"
                    class="invalid-feedback-custom"
                  >Group konsumen Non GT harus di isi.</div>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col sm="6">
                <b-form-group label-for="address" label="Alamat">
                  <b-form-textarea
                    id="address"
                    :rows="3"
                    :max-rows="6"
                    v-model="$v.warehouseForm.address.$model"
                    :state="!$v.warehouseForm.address.$invalid"
                  ></b-form-textarea>
                  <b-form-invalid-feedback>Alamat harus di isi.</b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <b-col sm="6">
                <b-form-group label-for="description" label="Description">
                  <b-form-textarea
                    id="description"
                    :rows="3"
                    :max-rows="6"
                    v-model="$v.warehouseForm.description.$model"
                    :state="!$v.warehouseForm.description.$invalid"
                  ></b-form-textarea>
                  <b-form-invalid-feedback>Description harus di isi.</b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>
          </b-form>
        </div>

        <div slot="modal-footer" class="float-right">
          <div v-if="!loadingSubmit">
            <b-button type="button" size="sm" variant="danger" @click="cancelAdd">
              <i class="fa fa-undo"></i> Back
            </b-button>&nbsp;
            <b-button
              type="button"
              size="sm"
              variant="primary"
              @click="submitAdd"
              :disabled="$v.warehouseForm.$invalid"
            >
              <i class="fa fa-save"></i> Save
            </b-button>
          </div>
        </div>
      </b-modal>
    </b-row>
  </div>
</template>

<script>
import axios from "axios";
import globalTable from "@/templates/Table.vue";
import interfaces from "@/templates/_interfaces.js";
import { required, email } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";
import { ModelSelect, MultiSelect } from "vue-search-select";
import loading from "@/templates/Loading.vue";

export default {
  name: "warehouse",
  components: { globalTable, ModelSelect, MultiSelect, loading },
  props: {
    tableDetail: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      warehouse: [],
      listCoverageNonGT: [],
      listCoverageGT: [],
      loading: false,
      loadingSubmit: false,
      item_related_gt: [],
      item_related_non_gt: [],
      isEdit: false,
      fields: [
        { key: "name", sortable: true },
        { key: "prefix", label: "Inisial", sortable: true },
        { key: "total_customer_gt", label: "Handle GT", sortable: true },
        {
          key: "total_customer_non_gt",
          label: "Handle Non GT",
          sortable: true
        },
        { key: "action", class: "text-center width-80" }
      ],
      warehouseForm: interfaces.warehouse
    };
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error"
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info"
    }
  },
  validations: {
    warehouseForm: {
      name: { required },
      prefix: { required },
      related_non_gt: { },
      related_gt: { },
      address: {},
      description: {}
    }
  },
  methods: {
    init: function() {
      this.loading = true;
      this.getData();
      this.getDropdown();
    },
    getData: function() {
      this.axios
        .get("web/warehouse/all/")
        .then(response => {
          this.warehouse = response.data.data;
        })
        .catch(error => {})
        .finally(() => {
          this.loading = false;
        });
    },
    getDropdown: function() {
      this.axios
        .get("web/dropdown/warehouse-related/")
        .then(response => {
          this.listCoverageNonGT = response.data.coverage_non_gt;
          this.listCoverageGT = response.data.coverage_gt;
        })
        .catch(error => {})
        .finally(() => {});
    },
    resetForm: function() {
      this.isEdit = false;
      this.resetItem();
      for (var a in interfaces.warehouse) {
        interfaces.warehouse[a] = null;
      }
      this.warehouseForm = interfaces.warehouse;
    },
    onSelectGT(items, lastSelectItem) {
      this.item_related_gt = items;
      this.warehouseForm.related_gt = items;
    },
    onSelectNonGT(items, lastSelectItem) {
      this.item_related_non_gt = items;
      this.warehouseForm.related_non_gt = items;
    },
    resetItem() {
      this.item_related_gt = []; // reset
      this.item_related_non_gt = []; // reset
    },
    submitAdd: function(evt) {
      evt.preventDefault();
      if (confirm("Apakah anda manambahkan gudang baru ?")) {
        this.loadingSubmit = true;
        this.axios
          .post("web/warehouse/add/", this.warehouseForm)
          .then(response => {
            if (response.data.status === 2000) {
              this.showInfoNotification({
                title: "Tambah Gudang",
                message: response.data.message
              });
              this.$router.push({ path: "all/detail/" + response.data.id });
            }
          })
          .catch(error => {
            this.expired(error);
          })
          .finally(() => {
            this.loadingSubmit = false;
            this.init();
          });
      }
    },
    cancelAdd: function() {
      this.$refs.myModalRef.hide();
    },
    expired: function(error, title) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired"
        });
      } else {
        this.showErrorNotification({
          title: title,
          message: error.response.data.message
        });
      }
    }
  },
  mounted() {
    this.init();
  }
};
</script>

<style>
</style>
